/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InsuranceEligibilityCheckReport
 */
export interface InsuranceEligibilityCheckReport {
    /**
     * 
     * @type {string}
     * @memberof InsuranceEligibilityCheckReport
     */
    report_s3_key?: string;
    /**
     * 
     * @type {string}
     * @memberof InsuranceEligibilityCheckReport
     */
    report_access_url?: string;
}

/**
 * Check if a given object implements the InsuranceEligibilityCheckReport interface.
 */
export function instanceOfInsuranceEligibilityCheckReport(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InsuranceEligibilityCheckReportFromJSON(json: any): InsuranceEligibilityCheckReport {
    return InsuranceEligibilityCheckReportFromJSONTyped(json, false);
}

export function InsuranceEligibilityCheckReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): InsuranceEligibilityCheckReport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'report_s3_key': !exists(json, 'report_s3_key') ? undefined : json['report_s3_key'],
        'report_access_url': !exists(json, 'report_access_url') ? undefined : json['report_access_url'],
    };
}

export function InsuranceEligibilityCheckReportToJSON(value?: InsuranceEligibilityCheckReport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'report_s3_key': value.report_s3_key,
        'report_access_url': value.report_access_url,
    };
}

